 
export const transcripts = state => {
  return state.transcripts;
};

export const texte = state => {
  return state.texte;
};

export const werbe = state => {
  return state.werbe;
};

export const bibliographie = state => {
  return state.bibliographie;
}; 


// WEBPACK FOOTER //
// ./src/store/getters.js